import { z } from 'zod';
import { isoDateSchema, timeSchema, uuidSchema } from './common.js';
import { messengerSchema } from './funnel.js';
export const slotKindSchema = z.enum(['permanent', 'custom']);
/** Постоянные слоты из прототипа: встречи по будням в это время. */
export const DEFAULT_SLOT_TIMES = ['10:00', '13:00', '16:00'];
/** Сетка расписания рабочего дня: с 09:00 до 18:00 по получасу. */
export function daySlots() {
    const slots = [];
    for (let hour = 9; hour <= 18; hour++) {
        const hh = String(hour).padStart(2, '0');
        slots.push(`${hh}:00`);
        if (hour < 18)
            slots.push(`${hh}:30`);
    }
    return slots;
}
export const createSlotSchema = z.object({
    time: timeSchema,
    kind: slotKindSchema.default('custom'),
    weekday: z.coerce.number().int().min(1).max(7).optional(),
    zoomUrl: z.string().trim().url('Укажите ссылку целиком, вместе с https://'),
});
export const createMeetingSchema = z.object({
    date: isoDateSchema,
    time: timeSchema,
    slotId: uuidSchema.optional(),
    zoomUrl: z.string().trim().url('Укажите ссылку целиком, вместе с https://').optional(),
    /** Выпустить пригласительную ссылку сразу вместе со встречей. */
    withInvite: z.boolean().default(true),
});
export const meetingOutcomeSchema = z.object({
    zoomCount: z.coerce.number().int().min(0).max(1000),
    maxCount: z.coerce.number().int().min(0).max(1000),
    telegramCount: z.coerce.number().int().min(0).max(1000),
});
/*
 * Шаблоны и скрипты общие для всех: их правит любой рекрутёр, и правка
 * сразу видна остальным. Отдельного владельца у записи нет намеренно —
 * это справочник команды, а не личные заметки.
 */
export const messageTemplateSchema = z.object({
    messenger: messengerSchema,
    title: z.string().trim().min(1, 'Заполните заголовок').max(120),
    body: z.string().trim().min(1, 'Заполните текст').max(4000),
    sortOrder: z.number().int().min(0).max(999).default(0),
});
export const scriptSchema = z.object({
    title: z.string().trim().min(1, 'Заполните заголовок').max(120),
    body: z.string().trim().min(1, 'Заполните текст').max(20000),
    sortOrder: z.number().int().min(0).max(999).default(0),
});
//# sourceMappingURL=meetings.js.map